import React from 'react';

import s from './styles.module.scss';

interface IProps {
  children: React.ReactNode;
}

const ScriptWrapper: React.FC<IProps> = ({ children }) => {
  return (
    <div className={s.script}>
      <p>Script:</p>
      {children}
    </div>
  );
};

export default ScriptWrapper;
